import apiSportsEvents from '@/api/sports-events'

const state = {
  error: null,
  isSubmitting: false,
}

export const mutationTypes = {
  addSportsEventTrainersStart:
    '[add sportsEvent Trainers] Create sportsEvent Trainers start',
  addSportsEventTrainersSuccess:
    '[add sportsEvent Trainers] Create sportsEvent Trainers success',
  addSportsEventTrainersFailure:
    '[add sportsEvent Trainers] Create sportsEvent Trainers failure',
}

export const actionTypes = {
  addSportsEventTrainers:
    '[add sportsEvent Trainers] Create sportsEvent Trainers',
}

const mutations = {
  [mutationTypes.addSportsEventTrainersStart](state) {
    state.isSubmitting = true
    state.error = null
  },

  [mutationTypes.addSportsEventTrainersSuccess](state) {
    state.isSubmitting = false
  },

  [mutationTypes.addSportsEventTrainersFailure](state, payload) {
    state.error = payload
    state.isSubmitting = false
  },
}

const actions = {
  [actionTypes.addSportsEventTrainers](context, {trainer, id}) {
    context.commit(mutationTypes.addSportsEventTrainersStart)
    return new Promise((resolve) => {
      apiSportsEvents
        .addSportsEventsTrainers(trainer, id)
        .then((response) => {
          context.commit(mutationTypes.addSportsEventTrainersSuccess)
          resolve(response.data)
        })
        .catch((resolve) => {
          context.commit(
            mutationTypes.addSportsEventTrainersFailure,
            resolve.response.data.errors
          )
        })
    })
  },
}

export default {
  state,
  mutations,
  actions,
}
